// Memoized selectors for the Employee Session V2 slice.
// Keeping selectors thin — view-level memoization happens in the components.

export const sessionDataSelector = (state) =>
  state.employeeSessionV2?.sessionData;
export const loadingSessionReportsSelector = (state) =>
  !!state.employeeSessionV2?.loadingSessionReports;
export const auditLogSelector = (state) =>
  state.employeeSessionV2?.auditLog || [];
export const ownerSettingsSelector = (state) =>
  state.employeeSessionV2?.ownerSettings;
export const duplicateScoresSelector = (state) =>
  state.employeeSessionV2?.duplicateScores || [];
export const localDecisionsSelector = (state) =>
  state.employeeSessionV2?.localDecisions || {};

export const bankTransactionsSelector = (state) =>
  state.employeeSessionV2?.sessionData?.bank || [];
export const expenseTransactionsSelector = (state) =>
  state.employeeSessionV2?.sessionData?.expenses || [];
export const bonusesSelector = (state) =>
  state.employeeSessionV2?.sessionData?.bonuses || [];
export const rafflesSelector = (state) =>
  state.employeeSessionV2?.sessionData?.raffles || [];
export const pointsSelector = (state) =>
  state.employeeSessionV2?.sessionData?.points || [];
export const ticketOutsSelector = (state) =>
  state.employeeSessionV2?.sessionData?.ticketOuts || [];
export const closingCashSelector = (state) =>
  state.employeeSessionV2?.sessionData?.cashLeft || 0;
